import { render, staticRenderFns } from "./SelectList.vue?vue&type=template&id=1ec22cd8&scoped=true&"
import script from "./SelectList.vue?vue&type=script&lang=js&"
export * from "./SelectList.vue?vue&type=script&lang=js&"
import style0 from "./SelectList.vue?vue&type=style&index=0&id=1ec22cd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec22cd8",
  null
  
)

export default component.exports